<div class="cm-contenido-central">
  <div>
    <mat-tab-group [selectedIndex]="activeTab" (selectedIndexChange)="onChangeTab($event)">
      <mat-tab label="Settings">
        <ng-template mat-tab-label>
          <mat-icon>settings</mat-icon>
        </ng-template>
        <div *ngIf="editMainContent">
          <form [formGroup]="metaForm">
            <div class="header-form-config">
              <h2 class="mat-h2">
                {{displayLang | i18nSelect: {'es': 'Enunciado de la meta', 'en': 'Statement of the goal', 'fr': "Déclaration de l'objectif", 'de': 'Zielsetzung'} }}
              </h2>
              <div>
                <button *ngFor="let idioma of idiomas" mat-button color="primary" [ngClass]="{'on': displayLang == idioma}"
                  [color]="displayLang == idioma ? 'warn' : ''" (click)="changeIdiomaDisplay(idioma)">
                    {{ idioma | i18nSelect: {'es': 'Español', 'en': 'English', 'fr': 'Français', 'de': 'Deutsche' } }}
                    <mat-icon *ngIf="metaForm.get('descripcion'+idioma.toUpperCase()).value === ''" matTooltip="No hay registro en este idioma." class="md-14 warning-lang">warning</mat-icon>
                </button>
              </div>
              <div *ngIf="_meta.id !== 0 && _meta.versiones">
                <span style="margin-right: 8px;"><strong>Versión activa: {{versionActual}}</strong></span>
                <button *ngIf="_meta.versiones.length > 1" style="margin-right: 8px;" mat-button [matMenuTriggerFor]="menu">Cambiar versión</button>
                <!-- form control name -->
                <mat-menu #menu="matMenu">
                  <div *ngFor="let version of _meta.versiones">
                    <button
                    *ngIf="version.id != _meta.versionId"
                    mat-menu-item (click)="cambiarVersion(version)" [value]="version.id">
                      Versión {{version.majorVersion + (version.minorVersion ? '.' + version.minorVersion : '')}}</button>
                  </div>
                </mat-menu>
                <button mat-raised-button color="primary" (click)="nuevaVersion()">Nueva versión</button>
              </div>
            </div>
            <div>
            </div>
            <div *ngFor="let idioma of idiomas">
              <div [ngStyle]="{'display': displayLang == idioma ? 'block' : 'none'}" class="enunciado-ck-container">
                <ckeditor appCkeditorImageDelete [name]="'html' + idioma.toUpperCase()" [editor]="classicEditor" [formControl]="metaForm.get('descripcion'+idioma.toUpperCase())"
                  [ngModelOptions]="{standalone: true}"
                  [config]="{language: idioma, url: ckeditorImageEndPoint, token: userToken, refreshUrl: refreshUrl, refreshToken: refreshToken, origen: 'Unidad', store: 'Estudio'}"
                  [class]="'espanol'"
                ></ckeditor>
                  <!-- No funciona el placeholder en ckeditor -->
                  <!-- [placeholder]="idioma | i18nSelect: {'es': 'Escriba aquí...', 'en': 'Write here...', 'fr': 'Ecrire ici...'}" -->
              </div>
            </div>
            <div class="inputs-layout">
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Tipo de meta</mat-label>
                <mat-select i18n-placeholder="@@tipoMeta" placeholder="Tipo de meta" formControlName="tipoMeta">
                  <mat-optgroup *ngFor="let tipoMeta of tiposMeta" [label]="tipoMeta.agrupador">
                    <mat-option *ngFor="let categoria of tipoMeta.categorias" [disabled]="!tipoMeta.isAuthorized"
                      [value]="categoria.id">
                      {{categoria.nombre}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
                <mat-error *ngIf="metaForm.get('tipoMeta').hasError('required')">Tipo de meta es obligatorio
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Editores</mat-label>
                <mat-select i18n-placeholder="@@editores" placeholder="Editores" formControlName="profesores" multiple>
                  <mat-option *ngFor="let profesor of profesores" [value]="profesor.id">
                    {{profesor.nombresApellidos}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Áreas</mat-label>
                <mat-select i18n-placeholder="@@areas" placeholder="Áreas" formControlName="areas" multiple>
                  <mat-optgroup *ngFor="let area of areas" [label]="area.nombre">
                    <mat-option *ngFor="let materia of area.materias" [value]="materia.id">
                      {{materia.nombre}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Cursos</mat-label>
                <mat-select i18n-placeholder="@@cursos" placeholder="Cursos" formControlName="cursos" multiple>
                  <mat-option *ngFor="let curso of cursosOpt" [value]="curso.id">{{curso.nombre}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Ámbitos</mat-label>
                <mat-select i18n-placeholder="@@ambitos" placeholder="Ámbitos" formControlName="ambitos" multiple>
                  <mat-optgroup *ngFor="let ambito of ambitos" [label]="ambito.nombre">
                    <mat-option *ngFor="let categoria of ambito.categorias" [value]="categoria.id">
                      {{categoria.nombre}}
                    </mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="inputs-layout__input">
                <mat-label>Tags</mat-label>
                <mat-select i18n-placeholder="@@tags" placeholder="Tags" formControlName="tags" multiple>
                  <mat-option *ngFor="let tag of tags" [value]="tag.id">{{tag.nombre}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </form>
        </div>
      </mat-tab>
      <!-- revisar contexto  -->
      <!-- <ng-container *ngIf="_meta.id != 0 && contexto == 'unidad_etapas'"> -->
      <ng-container *ngIf="_meta.id != 0">
        <mat-tab i18n-label="@@criteriosEvaluacion" label="CRITERIOS DE EVALUACIÓN">
          <div class="header-form-config">
            <h2 class="mat-h2">
              Criterios de evaluación ({{_meta.criterios.length}})
            </h2>
            <!-- <label class="langbar__label">Idioma:</label> -->
            <div>
              <button *ngFor="let idioma of idiomas" mat-button color="primary" [ngClass]="{'on': displayLang == idioma}"
                [color]="displayLang == idioma ? 'warn' : ''" (click)="changeIdiomaDisplay(idioma)">
                  {{ idioma | i18nSelect: {'es': 'Español', 'en': 'English', 'fr': 'Français', 'de': 'Deutsche' } }}
                  <mat-icon *ngIf="!_meta.criteriosIdiomasVista[idioma]" matTooltip="No hay registros en este idioma." class="md-14 warning-lang">warning</mat-icon>
              </button>
            </div>
            <button mat-raised-button color="primary" (click)="agregarCriterio(_meta.id)"
              style="margin: 24px 0 24px 0">Crear criterio
            </button>
          </div>
          <section>
            <ul>
              <ng-container *ngFor="let criterio of _meta.criterios; index as i">
                <li [attr.data-criterio-id]="criterio.id">
                  <div>
                    <div class="flex-wrap">
                      <p style="display: flex; align-items: center;">
                        <mat-icon class="" style="cursor: move;">drag_indicator</mat-icon>
                        <b i18n="@@criterio">Criterio {{i+1}}</b>
                      </p>
                      <span class="spacer"></span>
                      <button mat-icon-button class="" (click)="agregarNivelCriterio(criterio)"
                        matTooltip="Agregar nuevo nivel">
                        <mat-icon class="">playlist_add</mat-icon>
                      </button>
                      <button mat-icon-button class="" (click)="eliminarNivelCriterio(criterio.id, 0)"
                        i18n-matTooltip="@@eliminarCriterio" matTooltip="Eliminar criterio de evaluación">
                        <mat-icon class="">close</mat-icon>
                      </button>
                    </div>
                    <div *ngIf="displayLang" class="criterio">
                      <mat-form-field appearance="outline">
                        <mat-label>Criterio</mat-label>
                        <div *ngFor="let idioma of criterio.idiomas">
                          <textarea *ngIf="idioma.idioma === displayLang.toLowerCase()" matInput rows="5" [(ngModel)]="idioma.nombre" (blur)="guardarCriterio(criterio, displayLang)"
                            (keydown)="setPristine($event.keyCode, criterio)" class="criterio__main">
                                      {{idioma.nombre}}
                                  </textarea>
                        </div>
                        <textarea *ngIf="criterio.idiomas.length === 0" matInput rows="7" [(ngModel)]="criterio.nombre" (blur)="guardarCriterio(criterio, displayLang)"
                          (keydown)="setPristine($event.keyCode, criterio)" class="criterio__main">
                        </textarea>
                      </mat-form-field>
                      <div class="criterio__level">
                        <ng-container *ngFor="let criterioNivel of criterio.niveles; index as y">
                          <div class="flex-wrap">
                            <span class="spacer"></span>
                            <button *ngIf="y>0" mat-icon-button class=" "
                              (click)="eliminarNivelCriterio(criterio.id, criterioNivel.id)"
                              i18n-matTooltip="@@eliminarNivel" matTooltip="Eliminar nivel">
                              <mat-icon class="">close</mat-icon>
                            </button>
                          </div>
                          <div class="criterio__row">
                            <ng-container *ngFor="let criterioHijo of criterioNivel.criterios">
                              <div class="criterio__level-cont">
                                <mat-form-field appearance="outline" class="full-width">
                                  <mat-label>
                                    {{criterioHijo.escala.nombre}}
                                  </mat-label>
                                  <div *ngFor="let idioma of criterioHijo.idiomas">
                                    <textarea *ngIf="idioma.idioma === displayLang.toLowerCase()" matInput rows="5" [(ngModel)]="idioma.nombre"
                                      (blur)="guardarCriterio(criterioHijo, displayLang)"
                                      (keydown)="setPristine($event.keyCode, criterioHijo)">{{idioma.nombre}}
                                    </textarea>
                                  </div>
                                  <textarea *ngIf="criterioHijo.idiomas.length === 0" matInput rows="5" [(ngModel)]="criterioHijo.nombre"
                                    (blur)="guardarCriterio(criterioHijo)"
                                    (keydown)="setPristine($event.keyCode, criterioHijo)">{{criterioHijo.nombre}}
                                  </textarea>
                                </mat-form-field>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </li>
              </ng-container>
            </ul>
          </section>
        </mat-tab>
      </ng-container>
      <ng-container *ngIf="contexto == 'unidad_etapas'">
        <mat-tab i18n-label="@@comentarios" label="COMENTARIOS">
          <glm-comentarios [comentarios]="comentariosMeta" [targetID]="metaUnidadID" [origen]="'UnidadMeta'">
          </glm-comentarios>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
</div>
